import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';

export function createUsage() : ParameterType
{
    const desc = (<>
        <h3>Usage</h3>
        <p>Usage statistics for API requests, including token counts and processing duration.</p>
        </>);

    return {
        id          : "Usage",
        name        : "Usage",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "duration_ms",
                "type"        : "number",
                "description" : <p>The time taken to process the request in milliseconds, excluding setup time.</p>,
                "optional"    : false
            },
            {
                "name"        : "input_tokens",
                "type"        : "number",
                "description" : <p>The number of tokens in the input messages.</p>,
                "optional"    : false
            },
            {
                "name"        : "output_tokens",
                "type"        : "number",
                "description" : <p>The number of tokens in the generated response.</p>,
                "optional"    : false
            }
        ]
    };
}

